import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserStatusComponent } from '../../user/user-status/user-status.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppService, UserService, UserNotificationComponent } from 'briteatlib';
import { PendingOrderBadgeComponent } from '../../panel/pending-order-badge/pending-order-badge.component';
import { SharedService } from '../../../services/shared.service';
import { HeaderMenuComponent } from '../../shohreh/header-menu/header-menu.component';

@Component({
  selector: 'brt-layout-header',
  standalone: true,
  imports: [
    CommonModule, RouterModule, 
    UserStatusComponent, UserNotificationComponent, PendingOrderBadgeComponent, HeaderMenuComponent
  ],
  templateUrl: './layout-header.component.html',
  styleUrl: './layout-header.component.scss'
})
export class LayoutHeaderComponent {
  user: any;
  business: any;
  hq: any;
  isDesktop: boolean;
  constructor(userService: UserService, appService: AppService, sharedService: SharedService) {
    appService.activeBusiness$.pipe(takeUntilDestroyed()).subscribe(_ => {
      this.business = _;
    });
    appService.activeHq$.pipe(takeUntilDestroyed()).subscribe(_ => {
      this.hq = _;
    });
    userService.current$.pipe(takeUntilDestroyed()).subscribe(_ => this.user = _);
    
    sharedService.isDesktop$.pipe(takeUntilDestroyed()).subscribe(isDesktop => this.isDesktop = isDesktop); 
  }
  ngOnInit() {
  }
}
